export class CommunicationModel {
    email: boolean = true;
    sms?: boolean;
    phone?: boolean;
}